<div class="flex flex-col gap-6">
  <div data-bound-text-slash-anchor>
    <lib-signal-textarea
      label="Demo text"
      placeholder="Write something…"
      [trigger]="'/'"
      [handlebars]="true"
      [value]="textareaValue()"
      (valueChange)="onTextareaValueChange($event)"
      (triggerActivated)="onTextareaTrigger($event)" />
  </div>

  <div data-bound-text-slash-anchor>
    <lib-signal-text-field
      label="Demo field"
      placeholder="Write something…"
      [trigger]="'/'"
      [handlebars]="true"
      [value]="fieldValue()"
      (valueChange)="onFieldValueChange($event)"
      (triggerActivated)="onFieldTrigger($event)" />
  </div>

  <app-bound-text-slash-menu
    [open]="slashMenuOpen()"
    [query]="slashQuery()"
    [anchorRect]="slashAnchor()"
    (select)="onSlashSelect($event)"
    (dismiss)="onSlashDismiss()" />
</div>
